var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcThumbsupYellow = function SvgIcThumbsupYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "-0.5 -0.5 14.5 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC01E",
    stroke: "#16181C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.3 3.634h-.8a1 1 0 0 0-1 1v6.864a1 1 0 0 0 1 1h.8a1 1 0 0 0 1-1V4.634a1 1 0 0 0-1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#16181C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.3 5.184v5.313a2 2 0 0 0 2 2h4.582a1.666 1.666 0 0 0 1.608-1.228l1.305-4.792a1.666 1.666 0 0 0-1.608-2.104h-2.73v-2.54A1.333 1.333 0 0 0 7.124.5H7.1a1.33 1.33 0 0 0-1.113.6z"
  })));
};
export default SvgIcThumbsupYellow;